import { Col, Row } from "antd";
import React from "react";

interface ChangeLogContentItems {
  content: string;
}

const highlightChangeLogs: ChangeLogContentItems[] = [
  { content: "Connect wallet plugin" },
  { content: "Asset Detail" },
  { content: "User inventory" },
];
export default function ChangeLogs() {
  return (
    <Row
      gutter={[0, 12]}
      style={{ background: "#FFE4DB", padding: '24px 32px', borderRadius: 24 }}
    >
      <Col xs={24}>
        <p className="w-font-md fw-600" >
          Highlight Notes {" "}
          <span className="fw-500" style={{color:'#99472C'}}>Latest library updates: 05/29/2023</span>
        </p>
      </Col>
      <Col xs={24}>
        <Row gutter={[0, 12]}>
          {highlightChangeLogs.map((c) => (
            <Col xs={12}>
              <Row gutter={[12, 0]}>
                <Col>
                  <img src="icon/check.svg" alt={c.content} />
                </Col>
                <Col>
                  <p className="w-font-md fw-500" style={{color:'#99472C'}}>{c.content}</p>
                </Col>
              </Row>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
}
